// extracted by mini-css-extract-plugin
export default {"label":"SuperCheckbox_label__6sUAB","checkbox":"SuperCheckbox_checkbox__iSnrJ","spanClassName":"SuperCheckbox_spanClassName__dsfqq"};